import { extend } from 'VeeValidate'
import * as rules from 'VeeValidateRules'
import $ from 'jQuery';

export default function setupValidation() {

    extend('email', rules.email);
    extend('integer', rules.integer);
    extend('max', rules.max);
    extend('max_value', rules.max_value);
    extend('min', rules.min);
    extend('min_value', rules.min_value);
    extend('regex', rules.regex);
    extend('required', rules.required);

    extend('phone', value => {
        let regex = /^((\+423)|(\+41\s?\d{2})|(\d{3}))\s?(\d{3})\s?(\d{2})\s?(\d{2})$/g;
        return regex.test(value);
    });

    extend('cumulus', value => {
        //basic check: number should be 9 digits
        let regex = /^\d{9}$/g;
        if (!regex.test(value))
            return false;

        //calculate checkDigit and validate:
        let checkSum = ('2099' + value).split('').reduce(function (p, v, i) {
            return i % 2 == 0 ? p + 1 * v : p + 3 * v;
        }, 0);

        //checksum must be 0 if cumulus is valid
        return checkSum % 10 === 0;
    });

    extend('checkboxChecked', value => {
        return value === true;
    });

    extend('dse', value => {
        return value === true;
    });

    extend('address_valid', async value => {
        if (!value || !value.street || !value.zipcode || !value.city)
            return false;

        var reqData = { street: value.street, houseNr: value.houseNr, zipcode: value.zipcode, city: value.city };
        var response = await $.get('/migrolapi/' + window.CONFIG.language + '/places/VerifyAddress', reqData).promise();
        return response && response.isValid;
    }, {
        immediate: false
    });
}